import { render } from "./long-insure.vue?vue&type=template&id=614534ff&scoped=true&ts=true"
import script from "./long-insure.vue?vue&type=script&lang=ts"
export * from "./long-insure.vue?vue&type=script&lang=ts"

import "./long-insure.vue?vue&type=style&index=0&id=614534ff&scoped=true&lang=stylus"

import exportComponent from "/Users/rong.chen/data/zd/pc-customer-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-614534ff"]])

export default __exports__